import React from 'react'
import { Switch } from 'react-router-dom'
import Loadable from './Loadable'
import { PublicRoute } from '../../../lib/routePermission'


const AsyncHome = Loadable({
    loader: () => import('../../services/components/pages/main')
})

const AsyncFilter = Loadable({
    loader: () => import('../../services/components/pages/filter')
})

const AsyncNotFound = Loadable({
    loader: () => import('../../ui/components/NotFound')
})


export default () => (
    <Switch>
        <PublicRoute exact path='/' component={AsyncHome} />
        <PublicRoute exact path='/filter' component={AsyncFilter} />
        <PublicRoute component={AsyncNotFound} />
    </Switch>
)


// WEBPACK FOOTER //
// ./src/features/ui/components/Routes.js